import { h, FunctionalComponent } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { WithStyles, withStyles } from '../../style';
import * as appStyles from '../../assets/global.scss';
import { getIcon } from '../../services';
import * as styles from './Icon.scss';
import { Properties } from '../types';

export interface IconProps extends Properties {
  iconName: string;
  iconCategory?: string;
}

type IconRenderProps = IconProps & WithStyles;

const Icon: FunctionalComponent<IconProps> = withStyles(
  styles,
  appStyles
)(({ tx, iconName, iconCategory, ...props }: IconRenderProps) => {
  const [icon, setIcon] = useState(null);
  useEffect(() => {
    try {
      getIcon(iconName, iconCategory).then(setIcon);
    } catch (e) {}
  }, [iconName, iconCategory]);

  return <div {...props} class={tx(props.class, 'bw-icon')} dangerouslySetInnerHTML={{ __html: icon }} />;
});

export default Icon;
